import { proxy } from 'valtio';
import type { CanvasData } from '@/types';
import type { CanvasPreviewStore } from '../types';

export interface CanvasPreviewActions {
  setPreview: (
    canvasId: string,
    data: CanvasData,
    operationMode?: 'replace' | 'append' | 'prepend' | 'merge'
  ) => void;
  clearPreview: (canvasId: string) => void;
}

export function createCanvasPreviewStore(initialState?: Partial<CanvasPreviewStore>) {
  const store = proxy<CanvasPreviewStore>({
    previews: {},
    ...initialState,
  });

  const cloneCanvasData = (canvas: CanvasData): CanvasData => {
    try {
      return typeof structuredClone === 'function'
        ? structuredClone(canvas)
        : JSON.parse(JSON.stringify(canvas)) as CanvasData;
    } catch {
      return JSON.parse(JSON.stringify(canvas)) as CanvasData;
    }
  };

  const actions: CanvasPreviewActions = {
    setPreview(canvasId, data, operationMode = 'replace') {
      store.previews[canvasId] = {
        canvasId,
        data: cloneCanvasData(data),
        operationMode,
        updatedAt: new Date(),
      };
    },
    clearPreview(canvasId) {
      if (store.previews[canvasId]) {
        delete store.previews[canvasId];
      }
    },
  };

  return { store, actions };
}

export type CanvasPreviewStoreInstance = ReturnType<typeof createCanvasPreviewStore>;
